import { render, staticRenderFns } from "./ReportDescriptionCard.vue?vue&type=template&id=94727b30&scoped=true&"
import script from "./ReportDescriptionCard.vue?vue&type=script&lang=ts&"
export * from "./ReportDescriptionCard.vue?vue&type=script&lang=ts&"
import style0 from "./ReportDescriptionCard.vue?vue&type=style&index=0&id=94727b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94727b30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VForm,VTextarea})
